import { DataSharingService } from './../../services/common/data-sharing.service';
import { PopoverListarInscricoesComponent } from './components/popover-listar-inscricoes/popover-listar-inscricoes.component';
import { PopoverController } from '@ionic/angular';
import { InscricaoDTO } from '../../models/agendamento/inscricaoDTO';
import { InscricaoService } from './../../services/inscricao/inscricao.service';
import { UsuarioDTO } from '../../models/controle-acesso/usuarioDTO';
import { StorageService } from './../../services/storage/storage.service';
import { FunctionsService } from './../../services/common/functions.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { interval,  Subscription } from 'rxjs';

@Component({
  selector: 'app-header-gc',
  templateUrl: './header-gc.component.html',
  styleUrls: ['./header-gc.component.scss'],
})
export class HeaderGcComponent implements OnInit {

  

  showingSubmenu = '';
  usuarioLogado: UsuarioDTO = null;

  showNotificacaoNovosDocsEnviados: boolean = false;
  inscricoesRecentementeAtualizadas: InscricaoDTO[] = [];

  subscription: Subscription;

  constructor( private storageService : StorageService
             , private functionsService: FunctionsService
             , private inscricaoService: InscricaoService
             , private popoverController: PopoverController
             , private dataSharingService: DataSharingService ) { 

    this.usuarioLogado = this.storageService.getUsuarioLogado();  
    
    if(location.pathname.indexOf('modulo-gc/gc-analisar-documentacao-inscricao')>-1){
      this.showNotificacaoNovosDocsEnviados = true;
      
      this.getMostRecentUpdated('inscrição');

      //repetir a consulta de inscrições recentemente atualizadas a cada 60 segundos
      const source = interval(60000);
      this.subscription = source.subscribe(val => this.getMostRecentUpdated('inscrição'));

    }else if(location.pathname.indexOf('modulo-gc/gc-analisar-documentacao-matricula')>-1){
      
      this.showNotificacaoNovosDocsEnviados = true;
      this.getMostRecentUpdated('matrícula');

      //repetir a consulta de inscrições recentemente atualizadas a cada 60 segundos
      const source = interval(60000);
      this.subscription = source.subscribe(val => this.getMostRecentUpdated('matrícula'));
    }else {
      // Cancelar a execução de this.getMostRecentUpdated
      this.showNotificacaoNovosDocsEnviados = false;
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
    }
  }

  getMostRecentUpdated(tipoDocumentos: string){

    if(tipoDocumentos=='inscrição'){
      this.inscricaoService.findByUltimosDocsInscricaoEnviados().subscribe({
        next:(resp)=>{
          this.inscricoesRecentementeAtualizadas =  resp;
                  
        },
        error:(error)=>{
          console.log(error);
        }
      });
    
    }else if(tipoDocumentos == 'matrícula'){

      this.inscricaoService.findByUltimosDocsMatriculaEnviados().subscribe({
        next:(resp)=>{
          this.inscricoesRecentementeAtualizadas =  resp;
                  
        },
        error:(error)=>{
          console.log(error);
        }
      });

    }
    

  }

  ngOnInit() {
    
  }

  ngOnDestroy() {
    
    //mata a repetição das consultas de atualização da tela
    if(this.subscription){
      this.subscription.unsubscribe();
    }
    
  }

  /**
   * método disparado pelo evento mouseout 
   */
   hideSubmenu(event: any, idSubmenu: string) {    
    
    let element = document.getElementById(idSubmenu);
    //this.showingSubmenu = idSubmenu;  
    if(element){
      element.style.visibility = 'hidden';
    }
    
    
  }

  /**
   * método disparado pelo evento mouseenter 
   */
  showSubmenu(idSubmenu: string){
    
    this.showingSubmenu = idSubmenu;

    let element = document.getElementById(idSubmenu);
    
    if(element){
      element.style.visibility = 'visible';
    }
    

  }


  /*
  método usado para tablets, disparado através do click no menu, pois em tablet não tem cursor do mouse
  */
  showHideSubmenu(idSubmenu: string){
    
    this.showingSubmenu = idSubmenu;

    let element = document.getElementById(idSubmenu);
    
    if(element){

      if(element.style.visibility === 'visible'){
        element.style.visibility = 'hidden';
      }else{
        element.style.visibility = 'visible';
      }
    }
    
  }


  
  goToPath(path:string){

    if(path){
      this.functionsService.goToPath(path);
    }
  }
  

  logoff(){
    this.storageService.setUsuarioLogado(null);
    this.functionsService.goToPath('modulo-gc/gc-login');

  }


  async openPopoverListarInscricoes(event: any) {
    
    let tipoDocumentos = 'inscrição';
    if(location.pathname.indexOf('modulo-gc/gc-analisar-documentacao-matricula')>-1){
      tipoDocumentos = 'matrícula'
    }
    const popover = await this.popoverController.create({
      component: PopoverListarInscricoesComponent,
      componentProps: { 'inscricoes': this.inscricoesRecentementeAtualizadas
                      , 'tipoDocumentos': tipoDocumentos},
      translucent: false,
      showBackdrop: true,
      backdropDismiss: true,
      event: event,
      trigger: event,
      //cssClass: 'popover-listar-inscricoes', //definido no global.css     
      
    });

    await popover.present();
    
    //quando fechar o popover
    await popover.onDidDismiss().then((data)=>{

      //se tiver selecionado uma inscrição o campo data.data estará preenchido do contrário será null
      if(data && data.data){

        //informa ao serviço de notificação/compartilhamento de dados entre componentes o id da inscrição selecionada
        //este id será utilizado para preencher a tela de análise de docs com a inscrição selecionada
        this.dataSharingService.idInscricaoSelecionada.next( data.data ); 

        //atualiza a inscrição selecionada para ela sair da lista
        for(var i=0; i<this.inscricoesRecentementeAtualizadas.length; i++){
          
          //é a mesma inscrição?
          if( this.inscricoesRecentementeAtualizadas[i].id == data.data ){
            
            //atualiza o indicador de que o último envio de docs inscrição foi visualizado
            if(tipoDocumentos=='inscrição'){
              this.inscricoesRecentementeAtualizadas[i].dataUltimaVisualizacaoDocumentacaoInscricao = new Date();
            }else if(tipoDocumentos=='matrícula'){
              this.inscricoesRecentementeAtualizadas[i].dataUltimaVisualizacaoDocumentacaoMatricula = new Date();
            }

            //update da inscrição
            this.inscricaoService.update(this.inscricoesRecentementeAtualizadas[i]).subscribe({
              next:(resp)=>{

                //atualizar o contador no ícone de notificações
                this.getMostRecentUpdated(tipoDocumentos);

              },
              error:(error)=>{
                console.log(error);
              }
            });

          }
        }
        
      }
      
    });
    
  }
}
